<div
  class="modify-book-widget w-screen max-w-[343px] tablet:max-w-[520px] laptop:max-w-[928px] ultrawide:max-w-[1152px] px-[2px] laptop:px-[unset]"
>
  @if (guidedNavigationErrorMsg()) {
    <idp-guided-navigation-error-mach-core
      [errorMessage]="guidedNavigationErrorMsg() || ''"
    ></idp-guided-navigation-error-mach-core>
  }
  <ng-container
    [ngTemplateOutlet]="isDesktop() ? desktopView : mobileView"
  ></ng-container>
  <ng-template #desktopView>
    @if (isBookWidgetReady()) {
      @if (
        bookWidgetFields()?.tripTypesField?.selectedTripType !==
        tripTypeOptions.MULTI_CITY
      ) {
        <idp-modify-book-widget-desktop-ow-rt
          (infoIconClick)="infoIconClickHandler($event)"
          [bookWidgetAem]="bookWidgetAem()!"
          [bookWidgetFields]="bookWidgetFields()!"
          [recentSearchList]="recentSearchList()"
          [savedSearchList]="savedSearchList()"
          [searchModalTabs]="searchModalTabs()"
          [isFullscreen]="!isDesktop()"
          [predictiveSearchData]="predictiveSearchData()"
          [datepickerConfig]="datepickerConfig()"
          [isAdvancedSearchExpanded]="isAdvancedSearchExpanded()"
          (bookWidgetFieldChange)="bookWidgetFieldChange.emit($event)"
          (swapClicked)="swapAirports.emit($event)"
          (findFlight)="findFlightClickHandler()"
          (searchModalEvent)="searchModalEvent.emit($event)"
          (searchModalTriggerClicked)="handleModalTriggerClicked($event)"
          (bookWidgetFieldChange)="bookWidgetFieldChangeHandler($event)"
          (toggleAdvSearchExpandedEvent)="toggleAdvSearchExpanded()"
          (analyticsEvent)="analyticsEvent.emit($event)"
        ></idp-modify-book-widget-desktop-ow-rt>
      } @else {
        <idp-multi-city-desktop-modify
          [bookWidgetAem]="bookWidgetAem()!"
          [bookWidgetFields]="bookWidgetFields()!"
          [recentSearchList]="recentSearchList()"
          [savedSearchList]="savedSearchList()"
          [searchModalTabs]="searchModalTabs()"
          [isFullscreen]="!isDesktop()"
          [predictiveSearchData]="predictiveSearchData()"
          [datepickerConfig]="datepickerConfig()"
          [isAdvancedSearchExpanded]="isAdvancedSearchExpanded()"
          (bookWidgetFieldChange)="bookWidgetFieldChange.emit($event)"
          (swapClicked)="swapAirports.emit($event)"
          (findFlight)="findFlightClickHandler()"
          (searchModalEvent)="searchModalEvent.emit($event)"
          (searchModalTriggerClicked)="handleModalTriggerClicked($event)"
          (infoIconClick)="infoIconClickHandler($event)"
          (bookWidgetFieldChange)="bookWidgetFieldChangeHandler($event)"
          (addFlight)="addFlightsForMc.emit()"
          (removeFlight)="removeFlightForMc.emit()"
          (toggleAdvSearchExpandedEvent)="toggleAdvSearchExpanded()"
          (analyticsEvent)="analyticsEvent.emit($event)"
        ></idp-multi-city-desktop-modify>
      }
    } @else {
      <idp-modify-desktop-skeleton-mach-core></idp-modify-desktop-skeleton-mach-core>
    }
  </ng-template>
  <ng-template #mobileView>
    @if (isBookWidgetReady()) {
      @if (
        bookWidgetFields()?.tripTypesField?.selectedTripType !==
        tripTypeOptions.MULTI_CITY
      ) {
        <idp-modify-book-widget-mobile-ow-rt
          (infoIconClick)="infoIconClickHandler($event)"
          [bookWidgetAem]="bookWidgetAem()!"
          [bookWidgetFields]="bookWidgetFields()!"
          [recentSearchList]="recentSearchList()"
          [savedSearchList]="savedSearchList()"
          [searchModalTabs]="searchModalTabs()"
          [isFullscreen]="!isDesktop()"
          [predictiveSearchData]="predictiveSearchData()"
          [datepickerConfig]="datepickerConfig()"
          [isAdvancedSearchExpanded]="isAdvancedSearchExpanded()"
          (bookWidgetFieldChange)="bookWidgetFieldChange.emit($event)"
          (swapClicked)="swapAirports.emit($event)"
          (findFlight)="findFlightClickHandler()"
          (searchModalEvent)="searchModalEvent.emit($event)"
          (searchModalTriggerClicked)="handleModalTriggerClicked($event)"
          (bookWidgetFieldChange)="bookWidgetFieldChangeHandler($event)"
          (viewSearchOptionEvent)="onViewSearchOptionsHandler()"
          (toggleAdvSearchExpandedEvent)="toggleAdvSearchExpanded()"
          (analyticsEvent)="analyticsEvent.emit($event)"
        ></idp-modify-book-widget-mobile-ow-rt>
      } @else {
        <idp-multi-city-mobile-modify
          [bookWidgetAem]="bookWidgetAem()!"
          [bookWidgetFields]="bookWidgetFields()!"
          [recentSearchList]="recentSearchList()"
          [savedSearchList]="savedSearchList()"
          [searchModalTabs]="searchModalTabs()"
          [isFullscreen]="!isDesktop()"
          [predictiveSearchData]="predictiveSearchData()"
          [datepickerConfig]="datepickerConfig()"
          [isAdvancedSearchExpanded]="isAdvancedSearchExpanded()"
          (bookWidgetFieldChange)="bookWidgetFieldChange.emit($event)"
          (swapClicked)="swapAirports.emit($event)"
          (findFlight)="findFlightClickHandler()"
          (searchModalEvent)="searchModalEvent.emit($event)"
          (searchModalTriggerClicked)="handleModalTriggerClicked($event)"
          (infoIconClick)="infoIconClickHandler($event)"
          (bookWidgetFieldChange)="bookWidgetFieldChangeHandler($event)"
          (addFlight)="addFlightsForMc.emit()"
          (removeFlight)="removeFlightForMc.emit()"
          (viewSearchOptionEvent)="onViewSearchOptionsHandler()"
          (toggleAdvSearchExpandedEvent)="toggleAdvSearchExpanded()"
          (analyticsEvent)="analyticsEvent.emit($event)"
        ></idp-multi-city-mobile-modify>
      }
    } @else {
      <idp-modify-mobile-skeleton-mach-core></idp-modify-mobile-skeleton-mach-core>
    }
  </ng-template>

  <idp-info-modal-mach-core
    [showDialog]="showDialog()"
    [content]="infoPopUpModalData()"
    (close)="closeModal()"
  ></idp-info-modal-mach-core>
</div>
